import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Physicians = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  // Sample physicians data
  const [physicians] = useState([
    {
      id: 1,
      name: 'Dr. Sarah Johnson',
      specialty: 'Immunology',
      email: 'sarah.johnson@medical.com',
      phone: '+1 234-567-8902',
      patients: 45,
      lastActive: '2024-02-25',
      status: 'Active'
    },
    {
      id: 2,
      name: 'Dr. Michael Chen',
      specialty: 'Allergy',
      email: 'michael.chen@medical.com',
      phone: '+1 234-567-8903',
      patients: 38,
      lastActive: '2024-02-24',
      status: 'Active'
    },
    {
      id: 3,
      name: 'Dr. Emily Williams',
      specialty: 'Internal Medicine',
      email: 'emily.williams@medical.com',
      phone: '+1 234-567-8904',
      patients: 52,
      lastActive: '2024-02-23',
      status: 'Away'
    }
  ]);

  const handlePhysicianClick = (id) => {
    navigate(`/physicians/${id}`);
  };

  const filteredPhysicians = physicians.filter(physician =>
    physician.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    physician.specialty.toLowerCase().includes(searchTerm.toLowerCase()) ||
    physician.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="p-6">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-primary">Physicians</h1>
          <p className="text-neutral">Manage and view physician information</p>
        </div>
        {/* <button
          onClick={() => navigate('/physicians/new')}
          className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors duration-200"
        >
          <i className="fas fa-plus mr-2"></i>
          Add New Physician
        </button> */}
      </div>

      {/* Search Section */}
      
      {/* Physicians Table */}
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="max-h-[calc(100vh-220px)] overflow-y-auto">
        <table className="w-full">
          <thead className="bg-gray-50 sticky top-0 z-10">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral uppercase tracking-wider">Name</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral uppercase tracking-wider">Specialty</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral uppercase tracking-wider">Contact</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral uppercase tracking-wider">Patients</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral uppercase tracking-wider">Last Active</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral uppercase tracking-wider">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral uppercase tracking-wider">Actions</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-light"> 
            {/* {filteredPhysicians.map((physician) => (
              <tr key={physician.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="h-10 w-10 rounded-full bg-accent/20 flex items-center justify-center text-primary font-semibold">
                      {physician.name.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div className="ml-4">
                      <button
                        onClick={() => handlePhysicianClick(physician.id)}
                        className="text-sm font-medium text-primary hover:text-primary-dark transition-colors duration-200"
                      >
                        {physician.name}
                      </button>
                      <div className="text-sm text-neutral">{physician.email}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-primary">{physician.specialty}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-primary">{physician.phone}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-primary">{physician.patients}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-neutral">{physician.lastActive}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                    physician.status === 'Active' 
                      ? 'bg-green-100 text-green-800' 
                      : 'bg-yellow-100 text-yellow-800'
                  }`}>
                    {physician.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral">
                  <button 
                    onClick={() => handlePhysicianClick(physician.id)}
                    className="text-primary hover:text-primary-dark mr-3"
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button className="text-red-600 hover:text-red-800">
                    <i className="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))} */}
          </tbody>
        </table>
                   <div style={{padding:"20px", alignItems:"center",textAlign:"center"}}> No Physicians Found </div>
        </div>
      </div>
    </div>
  );
};

export default Physicians; 